//export const env = "http://localhost:8080/scdc-public/";
export const env = "/scdc-public/";
export const isIE = /*@cc_on!@*/ false || !!document.documentMode;
